import { isMobile } from "is-mobile";

export function getBrowserTypeForBankId() {
  if (isMobile({ tablet: true, featureDetect: true })) {
    if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
      // in iPhone / iPad it is important to know if it is not the default browser (Safari)
      if (/CriOS/.test(navigator.userAgent)) {
        return "iPhoneChrome";
      } else if (/FxiOS/.test(navigator.userAgent)) {
        return "iPhoneFirefox";
      } else if (/OPT/.test(navigator.userAgent)) {
        return "iPhoneOperaTouch";
      }
    } else if (/Android/.test(navigator.userAgent)) {
      return "android";
    }

    return "mobile";
  }

  return "desktop";
}
